// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayer":"VideoPlayer_VideoPlayer__8NEWl","VideoPlayerTag":"VideoPlayer_VideoPlayerTag__1r50y"};